import React, { memo, useMemo } from 'react'
import coinIcon from '../../../../../assets/coin.svg'
import coinsIcon from '../../../../../assets/Coins.svg'
import {
  AmountContainer,
  Description,
  Difference,
  Gift,
  Image,
  Item
} from './DcoinstHistory.styles'

export const DcoinsHistoryItem = memo(
  ({
    isOpen,
    senderAlert,
    numCoins,
    recipientUser,
    type,
    userInspiration,
    virtualGift,
    recipientAlert,
    item,
    funAvatar
  }) => {
    const isCoins =
      [
        'dailyTask',
        'welcomeGift',
        'seriesChallengeComplete',
        'levelUp'
      ].includes(type) || !type
    const giftSrc = virtualGift?.thumbImageUrl
    const imageSrc = useMemo(() => {
      if (type === 'marketplace' && item) {
        const { baseUrl, thumbImageFileLoc, thumbImageFileName } = item
        return `https://${baseUrl}/${thumbImageFileLoc}${thumbImageFileName}`
      }
      if (userInspiration)
        return (
          userInspiration?.idea?.cfThumbImageUrl ||
          userInspiration?.idea?.thumbImageFile?.url
        )
      if (funAvatar) return funAvatar?.thumbImageUrl
    }, [userInspiration, item, type, funAvatar])

    return (
      <Item>
        <AmountContainer>
          <img src={coinIcon} width={37} height={37} />{' '}
          <Difference>
            {recipientUser ? '+' : '-'}
            {numCoins}
          </Difference>
        </AmountContainer>
        <Description>{senderAlert || recipientAlert}</Description>
        {isCoins ? (
          <img src={coinsIcon} width={63} height={50} />
        ) : (
          <>
            {imageSrc && <Image src={imageSrc} />}
            {giftSrc && <Gift url={giftSrc} />}
          </>
        )}
      </Item>
    )
  }
)
